import { render } from "./updateCurrentSocketMutation.vue?vue&type=template&id=93fb7564"
import script from "./updateCurrentSocketMutation.vue?vue&type=script&lang=js"
export * from "./updateCurrentSocketMutation.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__